import { render } from "./NewClaimYearSelector.vue?vue&type=template&id=0b3fbc04&scoped=true&ts=true"
import script from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"
export * from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"

import "./NewClaimYearSelector.vue?vue&type=style&index=0&id=0b3fbc04&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3fbc04"]])

export default __exports__